module.exports = __webpack_public_path__ + "static/img/app.7ac3c95.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/app.png
// module id = 9720
// module chunks = 1